import i18n from 'src/locales';
import { WorkflowBuilderDialogType } from 'src/slices/ui/types';

export const getTextByType = (
  dialogType: WorkflowBuilderDialogType | null,
  isClassicWorkflowsDeprecated?: boolean,
) => {
  if (!dialogType) {
    return {};
  }

  if (dialogType === 'publish-version') {
    return {
      bodyText: i18n.t(
        'global-workflow-builder:dialogText.publishAgent.bodyText',
      ),
      buttonText: i18n.t(
        'global-workflow-builder:dialogText.publishVersion.buttonText',
      ),
      titleText: i18n.t(
        'global-workflow-builder:dialogText.publishVersion.titleText',
      ),
      toastText: i18n.t(
        'global-workflow-builder:dialogText.publishVersion.toastText',
      ),
    };
  }

  // Only classic dialog types remain; the customer-journey variants are gone.
  const typeText = i18n.t(
    'global-workflow-builder:dialogText.typeText.classic',
  );
  const typeSuffix = isClassicWorkflowsDeprecated
    ? ''
    : i18n.t('global-workflow-builder:dialogText.typeSuffix', { typeText });

  if (dialogType === 'switch-aa-to-classic') {
    return {
      bodyText: i18n.t(
        'global-workflow-builder:dialogText.replaceAndPublish.bodyText',
        {
          typeText,
        },
      ),
      buttonText: i18n.t(
        'global-workflow-builder:dialogText.replaceAndPublish.buttonText',
      ),
      titleText: i18n.t(
        'global-workflow-builder:dialogText.replaceAndPublish.titleText',
      ),
      toastText: i18n.t(
        'global-workflow-builder:dialogText.publishedSuccessToast',
        {
          typeSuffix,
        },
      ),
    };
  }

  if (dialogType === 'update-publish-classic') {
    return {
      bodyText: i18n.t(
        'global-workflow-builder:dialogText.updatePublish.bodyText',
        {
          typeSuffix,
        },
      ),
      buttonText: i18n.t(
        'global-workflow-builder:dialogText.updatePublish.buttonText',
      ),
      titleText: i18n.t(
        'global-workflow-builder:dialogText.updatePublish.titleText',
      ),
      toastText: i18n.t(
        'global-workflow-builder:dialogText.updatePublish.toastText',
        {
          typeSuffix,
        },
      ),
    };
  }

  return {
    bodyText: i18n.t(
      'global-workflow-builder:dialogText.publishAgent.bodyText',
    ),
    buttonText: i18n.t(
      'global-workflow-builder:dialogText.publishAgent.buttonText',
    ),
    titleText: i18n.t(
      'global-workflow-builder:dialogText.publishAgent.titleText',
    ),
    toastText: i18n.t(
      'global-workflow-builder:dialogText.publishedSuccessToast',
      {
        typeSuffix,
      },
    ),
  };
};
